import { ReactElement } from 'react'
import { Image, Text } from '../../Atoms'
import useStep from '../../Hooks/useStep'
import { ChoiceDialog, Flex } from '../../Molecules'
import Feedback from '../../Molecules/Feedback'
import { FeedbackDialogProps } from './props'
import { StyledFeedbackDialog } from './styles'

const FeedbackDialog = ({ ...props }: FeedbackDialogProps): ReactElement => {
    const [step, helpers] = useStep(3)

    const { choiceDialog, feedback, tyFeedbackText, tyFeedbackIcon } = props

    const choiceButtons = choiceDialog.buttons.map((button) => {
        return {
            text: button.text,
            onClick: () => {
                helpers.goToNextStep()
                button.onClick()
            },
        }
    })

    return (
        <StyledFeedbackDialog {...props}>
            {step === 1 ? (
                <ChoiceDialog
                    icon={choiceDialog.icon}
                    text={choiceDialog.text}
                    buttons={choiceButtons}
                />
            ) : step === 2 ? (
                <Feedback
                    {...feedback}
                    onClickButton={() => helpers.goToNextStep()}
                />
            ) : (
                <Flex alignItems="center" gap="8">
                    <Image src={tyFeedbackIcon} height={20} width={20} />
                    <Text bold primary>
                        {tyFeedbackText}
                    </Text>
                </Flex>
            )}
        </StyledFeedbackDialog>
    )
}

export default FeedbackDialog

export { StyledFeedbackDialog }
